import { isNumber } from '@teamsparta/utils';

import type { CommunityPost } from '@/api/community/post';

export function getPostType(post: CommunityPost) {
  if (post.poll?.pollOptions && post.poll?.pollEndDate) {
    return '투표';
  }

  if (isNumber(post.noticeNum)) {
    return '공지';
  }

  return '일반글';
}
